import { useEffect } from "react";
import { notification } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { clearNotification } from "../../store/reducers/slices/notification.slice";

const GlobalNotification = () => {
  const dispatch = useDispatch();
  const { message, description, type, placement, duration, style } =
    useSelector(({ notification }) => notification);

  useEffect(() => {
    if (message) {
      notification[type]({
        message,
        description,
        placement,
        duration,
        style,
      });

      dispatch(clearNotification());
    }
  }, [message, description, type, placement, duration, style, dispatch]);

  return null;
};

export default GlobalNotification;
